// The system banner is fixed at the top of the viewport and its height depends on the message length,
// so it publishes its height as a CSS variable that other fixed elements and layouts offset by.
// Tailwind classes can't interpolate these constants, so they use `top-[var(--system-banner-height,0px)]` directly.
export const SYSTEM_BANNER_HEIGHT_CSS_VAR = '--system-banner-height';
export const SYSTEM_BANNER_HEIGHT = `var(${SYSTEM_BANNER_HEIGHT_CSS_VAR}, 0px)`;
export const withSystemBannerOffset = (heightInPx: number) => `calc(${SYSTEM_BANNER_HEIGHT} + ${heightInPx}px)`;
